const updateMatchyFilterSelection = (panel) => {
  const selection = panel?.querySelector('[data-matchy-filter-selection]');
  if (!selection) return;

  const count = panel.querySelectorAll('[data-matchy-filter-option][aria-pressed="true"]').length;
  selection.textContent = count === 0 ? 'No filters selected' : `${count} ${count === 1 ? 'filter' : 'filters'} selected`;
};

document.querySelectorAll('[data-matchy-filter-panel]').forEach(updateMatchyFilterSelection);

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const filterOption = event.target.closest('[data-matchy-filter-option]');
  if (filterOption) {
    const group = filterOption.closest('[data-matchy-filter-group]');
    const panel = filterOption.closest('[data-matchy-filter-panel]');
    const willSelect = filterOption.getAttribute('aria-pressed') !== 'true';

    if (willSelect && group) {
      group.querySelectorAll('[data-matchy-filter-option][aria-pressed="true"]').forEach((option) => {
        option.setAttribute('aria-pressed', 'false');
        option.classList.remove('is-active');
      });
    }

    filterOption.setAttribute('aria-pressed', String(willSelect));
    filterOption.classList.toggle('is-active', willSelect);

    updateMatchyFilterSelection(panel);
    return;
  }

  const applyButton = event.target.closest('[data-matchy-filter-apply]');
  if (applyButton) {
    const panel = applyButton.closest('[data-matchy-filter-panel]');
    if (!panel) return;

    const selectedOptions = [...panel.querySelectorAll('[data-matchy-filter-option][aria-pressed="true"]')];
    const baseOption = selectedOptions.find((option) => option.dataset.matchyCollectionHandle);
    const collectionsUrl = panel.dataset.matchyCollectionsUrl || '/collections';
    const allProductsUrl = panel.dataset.matchyAllProductsUrl || `${collectionsUrl}/all`;
    const baseUrl = baseOption ? `${collectionsUrl}/${baseOption.dataset.matchyCollectionHandle}` : allProductsUrl;
    const tagHandles = [...new Set(
      selectedOptions
        .filter((option) => option !== baseOption)
        .map((option) => option.dataset.matchyTagHandle)
        .filter(Boolean),
    )].sort();
    const targetUrl = new URL(tagHandles.length ? `${baseUrl}/${tagHandles.join('+')}` : baseUrl, window.location.origin);
    const sortBy = new URL(window.location.href).searchParams.get('sort_by');
    if (sortBy) targetUrl.searchParams.set('sort_by', sortBy);
    window.location.assign(targetUrl.toString());
    return;
  }

  const filterToggle = event.target.closest('[data-matchy-filter-toggle]');
  if (filterToggle) {
    const group = filterToggle.closest('[data-matchy-filter-group]');
    const content = group?.querySelector('[data-matchy-filter-content]');
    if (!content) return;

    const expanded = filterToggle.getAttribute('aria-expanded') === 'true';
    filterToggle.setAttribute('aria-expanded', String(!expanded));
    content.hidden = expanded;
    return;
  }

  const showMoreButton = event.target.closest('[data-matchy-show-more]');
  if (!showMoreButton) return;

  const group = showMoreButton.closest('[data-matchy-filter-group]');
  if (!group) return;

  const expanded = group.classList.toggle('is-expanded');
  showMoreButton.textContent = expanded ? 'Show less' : 'Show more';
});
